import {Pipe, PipeTransform, ChangeDetectorRef} from "@angular/core";
import {ConfigurationService} from "./configuration.service";
import {Subscription} from "rxjs";

@Pipe({
    name: 'numberConfig',
    pure: false,
    standalone: false
})
export class NumberConfigPipe implements PipeTransform {
    configSpec: string = null;
    value: number = null;
    subscription: Subscription;

    constructor(private configurationService: ConfigurationService, private ref: ChangeDetectorRef) {
        this.subscription = configurationService.configurationChanges.subscribe((configSpec: string) => {
            if (configSpec === this.configSpec) {
                this.configSpec = null;
                this.value = null;
                this.ref.markForCheck();
            }
        })
    }

    transform(configSpec: string): number {
        if (configSpec !== this.configSpec) {
            this.configSpec = configSpec;
            this.value = null;
            this.configurationService.getNumber(configSpec).then((value: number) => {
                this.value = value;
                this.ref.markForCheck();
            });
        }
        return this.value;
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
